export const menuItems = {
  main: {
    text: 'MAIN',
    target: '#top_banner_sec'
  },
  // sector01: {
  //   text: 'OVERVIEW',
  //   target: '.sector02'
  // },
  // sector02: {
  //   text: 'BENEFITS',
  //   target: '.sector03'
  // },
  // sector03: {
  //   text: 'REQUIREMENTS',
  //   target: '.sector04'
  // },
  // sector04: {
  //   text: 'ITINERARY',
  //   target: '.sector05'
  // },
  contact: {
    text: 'CONTACT',
    target: '#sector_contact'
  },
  apply: {
    text: 'APPLY',
    target: '#sector_apply'
  }
}; 